module.exports = __webpack_public_path__ + "img/m.a6908be2.jpg";